/*
 * @Author: 冯杰
 * @Date: 2021-07-22 10:33:34
 * @LastEditTime: 2021-10-29 10:34:23
 * @LastEditors: Please set LastEditors
 * @Description: 分利经销商/分利统计
 */
import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import StatisicalFormTable from './statisical-form-table.js';

formCreate.component('StatisicalFormTable', StatisicalFormTable);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  props: {
    rowData: Object,
  },
  data() {
    return {
      rule: [],
      buttons: {
        submit: false, // 提交按钮
        close: false, // 关闭按钮
        submitAudit: false, // 报错并提交按钮
      },
      formFunctionCode: 'dealer-statistics',
      fields: [
        'accessTime',
        'agreementTotal',
        'cashAvailable',
        'cashTotal',
        'integralAvailable',
        'integralTotal',
        'orderAmountTotal',
        'orderTotal',
        'redPacketTotal',
        'scanTotal',
        'costTotal',
        'costAvailable',
        'redPacketAvailable',
      ],
    };
  },
  methods: {
    // 设置rule
    setRule(v) {
      const item = v;

      if (item.field === 'StatisicalFormTable') {
        item.props = {
          ...item.props,
          customerCode: this.rowData.customerCode,
        };
      }

      return item;
    },

    // 表单渲染完成后回调
    // 劫持数据 对数据进行操作
    formComplete() {
      this.disabled(true, this.fields);
      this.gettrmimenedata();
    },
    // 根据查询数据
    gettrmimenedata() {
      console.log('customerCode', this.rowData.customerCode);
      request
        .get('/cps/v1/web/participatorReport/findByParticipatorCodeAndType', {
          participatorCode: this.rowData.customerCode,
          participatorType: 1,
        })
        .then((res) => {
          if (!res.success) return;
          const obj = res.result;
          this.setValue({
            ...obj,
          });
        });
    },
    // 提交
    submit() {},
  },
};
